import { useState } from 'react'
import classNames from 'classnames'
import { HTMLTags } from '../../common-types'
import { StencilCDNImage } from '../../../../components/Common/StencilImage'
import Title from '@/stories/strapi-4/common-components/Title'

type TProps = {
  step?: string
  stepText?: string
  heading: string
  subHeading?: string
  card_data: {
    type: string
    image?: string
    text?: string
    aText?: string
    dataText?: { text: string }[]
  }[]
  image: string
  bgcolor: string
  headingColor: string
  headingType?: HTMLTags
  mainHeading?: string
}

const GuidesCard = ({
  widgetData,
  className,
}: {
  widgetData: TProps
  className?: string
}) => {
  const [selectedIdx, setselectedIdx] = useState<number>(0)
  const [selectedImageUrl, setselectedImageUrl] = useState<string>(
    widgetData.image,
  )

  return (
    <div>
      {widgetData.mainHeading && (
        <Title fontSize="size-40" className="mb-5 font-semibold">
          {widgetData.mainHeading}
        </Title>
      )}
      <div
        className={classNames(
          'flex w-full flex-col items-center gap-5 rounded-3xl px-4 py-5 md:flex-row md:items-start md:justify-between md:gap-0 md:px-10 md:py-10',
          widgetData.bgcolor,
          className,
        )}
      >
        <div className="flex w-full flex-col items-start justify-start md:w-1/2">
          {widgetData.step && (
            <Title
              fontSize="size-16"
              className="font-medium uppercase text-green-500"
              headingType="p"
            >
              {widgetData.step}
            </Title>
          )}
          <div className="text-brand-grey-dark flex w-full flex-col items-start justify-start gap-8">
            <div className="flex w-full flex-col items-start justify-start gap-1">
              {widgetData.heading && (
                <Title
                  fontSize="size-24"
                  className={classNames(
                    'text-2xl font-medium',
                    widgetData.headingColor,
                  )}
                  headingType={widgetData.headingType}
                >
                  {widgetData.heading}
                </Title>
              )}
              {widgetData.subHeading && (
                <Title
                  fontSize="size-16"
                  headingType="p"
                  className={classNames('font-medium', widgetData.headingColor)}
                >
                  {widgetData.subHeading}
                </Title>
              )}
            </div>

            {widgetData.card_data.length &&
              widgetData.card_data.map((field, idx) => {
                if (field.type === 'text') {
                  return (
                    Array.isArray(field.dataText) &&
                    field.dataText.map((el, index) => {
                      return (
                        <Title fontSize="size-16" headingType="p" key={index}>
                          {el.text}
                        </Title>
                      )
                    })
                  )
                } else if (field.type == 'pointers') {
                  return (
                    <ul
                      key={idx}
                      className="flex flex-col items-start justify-start gap-1 text-base"
                    >
                      {Array.isArray(field.dataText) &&
                        field.dataText.map((el, index) => {
                          return <li key={index}>{el.text}</li>
                        })}
                    </ul>
                  )
                } else if (field.type == 'animate') {
                  return (
                    <div
                      key={idx}
                      className={classNames(
                        `flex cursor-pointer flex-col items-start justify-start pl-2 text-white`,
                        {
                          'border-brand-blue-azureRadiance border-l-4':
                            idx === selectedIdx,
                        },
                        { 'text-opacity-70': idx !== selectedIdx },
                      )}
                      onClick={() => {
                        setselectedIdx(idx)
                        setselectedImageUrl(
                          widgetData.card_data[idx].image ?? '',
                        )
                      }}
                    >
                      {field.text && (
                        <Title
                          headingType="p"
                          fontSize="size-16"
                          className="hover:text-brand-white"
                        >
                          {field.text}
                        </Title>
                      )}
                      {field.aText && (
                        <Title
                          headingType="p"
                          fontSize="size-20"
                          className={classNames(
                            'font-medium text-white transition-all duration-500',
                            {
                              'max-h-0 overflow-hidden opacity-0':
                                idx !== selectedIdx,
                              'max-h-96 opacity-100': idx === selectedIdx,
                            },
                          )}
                        >
                          {field.aText}
                        </Title>
                      )}
                    </div>
                  )
                } else {
                  return null
                }
              })}
          </div>
        </div>
        {selectedImageUrl && (
          <StencilCDNImage
            src={selectedImageUrl}
            width={400}
            height={400}
            alt="guide us stock icon"
          />
        )}
      </div>
    </div>
  )
}

export default GuidesCard
